import React from 'react'
import PropTypes from 'prop-types'

import Text from '../Text/Text'
import styles from './notificationPanel.scss'

export const MESSAGES_LABELS = {
  error:
    'Ops, parece que um erro aconteceu enquanto suas notificações estavam sendo carregadas',
  empty: 'Você não tem novas notificações no momento'
}

const EmptyNotifications = ({ hasError }) => (
  <div className={styles.empty}>
    <Text
      label={hasError ? MESSAGES_LABELS.error : MESSAGES_LABELS.empty}
      labelFontSize="12px"
    />
  </div>
)

EmptyNotifications.defaultProps = {
  hasError: false
}

EmptyNotifications.propTypes = {
  hasError: PropTypes.bool
}

export default EmptyNotifications
